import { jsx as _jsx } from "react/jsx-runtime";
import { SvgNmrPeaks } from 'cheminfo-font';
export default function ShowHideMarkersButton({ data, onChangeMarkersVisibility, markersVisible, style, }) {
    const isMarkerVisible = (id) => {
        return markersVisible.findIndex((v) => v.id === id) !== -1;
    };
    if (data.peaks && data.peaks.values.length === 0) {
        return null;
    }
    return (_jsx("button", { style: {
            ...style,
            opacity: isMarkerVisible(data.id) && data.peaks && data.peaks.values.length > 0
                ? 1
                : 0.1,
        }, type: "button", onClick: () => onChangeMarkersVisibility(data), children: _jsx(SvgNmrPeaks, {}) }));
}
